import {
  SET_IS_POOQ_ZONE,
  SET_USER_LOGIN_INFO
} from '@/store/types/mutations.type'
import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'

const state = {
  isPooqZone: false,
  transitioning: false,
  showLnb: false,
  isVisibleUserProfile: false,
  isVisibleAlarms: false,
  isVisibleAdultCheckView: false,
  isVisibleLoginView: false,
  isVisibleListView: false,
  // beforeAdultCheckReferer: '',
  listViewParams: null,
  isNavigationMenu: true,
  csInfo: {}
}

const getters = {
  isPooqZone () {
    return state.isPooqZone
  },
  lnbStatus () {
    return state.showLnb
  },
  userInfo () {
    return state.userInfo
  },
  isVisibleAlarms () {
    return state.isVisibleAlarms
  },
  isVisibleAdultCheckView () {
    return state.isVisibleAdultCheckView
  },
  isVisibleUserProfile () {
    return state.isVisibleUserProfile
  },
  isVisibleLoginView () {
    return state.isVisibleLoginView
  },
  isVisibleListView () {
    return state.isVisibleListView
  },
  getListViewParams () {
    return state.listViewParams
  },
  isNavigationMenu () {
    return state.isNavigationMenu
  },
  csInfo () {
    return state.csInfo
  }

}

const actions = {}

const mutations = {
  [SET_IS_POOQ_ZONE] (state, isPooqZone) {
    state.isPooqZone = isPooqZone
  },
  showLnb (state) {
    disableBodyScroll()
    state.showLnb = true
  },
  hideLnb (state) {
    enableBodyScroll()
    state.showLnb = false
  },
  showUserProfile (state) {
    state.isVisibleUserProfile = true
  },
  hideUserProfile (state) {
    state.isVisibleUserProfile = false
  },
  showAlarms (state) {
    state.isVisibleAlarms = true
  },
  hideAlarms (state) {
    state.isVisibleAlarms = false
  },
  showAdultCheck (state) {
    state.isVisibleAdultCheckView = true
  },
  hideAdultCheck (state) {
    state.isVisibleAdultCheckView = false
  },
  showLoginView (state) {
    state.isVisibleLoginView = true
  },
  hideLoginView (state) {
    state.isVisibleLoginView = false
  },
  [SET_USER_LOGIN_INFO] (state, userLoginInfo) {
    state.userInfo = userLoginInfo
  },
  showNavigationMenu (state) {
    state.isNavigationMenu = true
  },
  hideNavigationMenu (state) {
    state.isNavigationMenu = false
  },
  setCsInfo (state, csInfo) {
    state.csInfo = csInfo
  }
}

export default { state, getters, actions, mutations }
